
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $cXtTj = parcelRequire("cXtTj");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $8f621f3867006eb3$export$e8ff3768de40dcb2 = ()=>(parcelRequire("9VWYf"));



var $hyOW3 = parcelRequire("hyOW3");


var $fDOrD = parcelRequire("fDOrD");


var $jv1SC = parcelRequire("jv1SC");

const $6e95e9a207754122$var$PRELOADER_SMART_CARD = 'smart-card';
const $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $6e95e9a207754122$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $6e95e9a207754122$var$ALL_PRELOADERS = [
    $6e95e9a207754122$var$PRELOADER_SMART_CARD,
    $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST,
    $6e95e9a207754122$var$PRELOADER_SMART_CREATION,
    $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG
];
let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$var$isPreloaderName(preloader) {
    return $6e95e9a207754122$var$ALL_PRELOADERS.includes(preloader);
}
function $6e95e9a207754122$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($6e95e9a207754122$var$isPreloaderName));
}
function $6e95e9a207754122$var$preloadSmartCard() {
    (0, $8f621f3867006eb3$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadAutoSuggest() {
    (0, $hyOW3.importAutoSuggest)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadSmartCreationWrapper() {
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadFeedbackFlag() {
    (0, $fDOrD.importFeedbackFlag)().catch(()=>{});
}
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $6e95e9a207754122$var$getEnabledPreloaders((0, $cXtTj.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CARD)) $6e95e9a207754122$var$preloadSmartCard();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST)) $6e95e9a207754122$var$preloadAutoSuggest();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CREATION)) $6e95e9a207754122$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG)) $6e95e9a207754122$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("9VWYf", function(module, exports) {

let $73b72e4c66f94571$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73b72e4c66f94571$var$load("j6n20"),
    $73b72e4c66f94571$var$load("gpnR1"),
    $73b72e4c66f94571$var$load("hzkGb"),
    $73b72e4c66f94571$var$load("aClTZ"),
    $73b72e4c66f94571$var$load("eRhBr"),
    $73b72e4c66f94571$var$load("1wtmT"),
    $73b72e4c66f94571$var$load("85Or1"),
    $73b72e4c66f94571$var$load("hZ2FX"),
    $73b72e4c66f94571$var$load("9ZFGK"),
    $73b72e4c66f94571$var$load("2hLAI"),
    $73b72e4c66f94571$var$load("dCilB"),
    $73b72e4c66f94571$var$load("h1yOv"),
    $73b72e4c66f94571$var$load("1T8H1"),
    $73b72e4c66f94571$var$load("fyKFO"),
    $73b72e4c66f94571$var$load("d9sg7"),
    $73b72e4c66f94571$var$load("l0N35"),
    $73b72e4c66f94571$var$load("bU9L5"),
    $73b72e4c66f94571$var$load("fuOfV"),
    $73b72e4c66f94571$var$load("iZR3N"),
    $73b72e4c66f94571$var$load("4zz48"),
    $73b72e4c66f94571$var$load("jXM1T"),
    $73b72e4c66f94571$var$load("cvcNg"),
    $73b72e4c66f94571$var$load("jw3lv"),
    $73b72e4c66f94571$var$load("7rqWx"),
    $73b72e4c66f94571$var$load("aIze1"),
    $73b72e4c66f94571$var$load("il8bj"),
    $73b72e4c66f94571$var$load("4N1MY"),
    $73b72e4c66f94571$var$load("kG5Ju"),
    $73b72e4c66f94571$var$load("39XCn"),
    $73b72e4c66f94571$var$load("3Cky6"),
    $73b72e4c66f94571$var$load("jL1Ke"),
    $73b72e4c66f94571$var$load("5MQ0D"),
    $73b72e4c66f94571$var$load("aFLSJ"),
    $73b72e4c66f94571$var$load("6fJCf"),
    $73b72e4c66f94571$var$load("duEFL"),
    $73b72e4c66f94571$var$load("6wr18"),
    $73b72e4c66f94571$var$load("1pJPT"),
    $73b72e4c66f94571$var$load("8zMmc"),
    $73b72e4c66f94571$var$load("4x9Jx"),
    $73b72e4c66f94571$var$load("7EorR"),
    $73b72e4c66f94571$var$load("ffEVr"),
    $73b72e4c66f94571$var$load("2EIkU"),
    $73b72e4c66f94571$var$load("Wowvf"),
    $73b72e4c66f94571$var$load("hhss7"),
    $73b72e4c66f94571$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("hyOW3", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("izjab"));
}
module.exports["importAutoSuggest"] = $04373e772f510be6$export$5531859f311f2932;

});

parcelRegister("izjab", function(module, exports) {

let $d84a5c4fd176b422$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d84a5c4fd176b422$var$load("hzkGb"),
    $d84a5c4fd176b422$var$load("aClTZ"),
    $d84a5c4fd176b422$var$load("6wr18"),
    $d84a5c4fd176b422$var$load("ffEVr"),
    $d84a5c4fd176b422$var$load("dGhn8"),
    $d84a5c4fd176b422$var$load("5omeF"),
    $d84a5c4fd176b422$var$load("2EIkU"),
    $d84a5c4fd176b422$var$load("eRhBr"),
    $d84a5c4fd176b422$var$load("hZ2FX"),
    $d84a5c4fd176b422$var$load("hhss7"),
    $d84a5c4fd176b422$var$load("kT6dz"),
    $d84a5c4fd176b422$var$load("aAWLw"),
    $d84a5c4fd176b422$var$load("lRgOm")
]).then(()=>parcelRequire('79mXg'));

});

parcelRegister("fDOrD", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));
module.exports["importFeedbackFlag"] = $e837e744ff2037be$export$1eafe3a5df99a0a0;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("a3J3m"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("a3J3m", function(module, exports) {

let $752d21ce99232bca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $752d21ce99232bca$var$load("4ZKBo"),
    $752d21ce99232bca$var$load("3WmaY"),
    $752d21ce99232bca$var$load("7TnhR"),
    $752d21ce99232bca$var$load("hUbK8"),
    $752d21ce99232bca$var$load("gwGEC"),
    $752d21ce99232bca$var$load("l5nRU"),
    $752d21ce99232bca$var$load("bx5S2"),
    $752d21ce99232bca$var$load("7fsAO"),
    $752d21ce99232bca$var$load("1tkCm"),
    $752d21ce99232bca$var$load("ipIDQ"),
    $752d21ce99232bca$var$load("7eTC9"),
    $752d21ce99232bca$var$load("agv3Q"),
    $752d21ce99232bca$var$load("garBx"),
    $752d21ce99232bca$var$load("6GBKZ"),
    $752d21ce99232bca$var$load("28xpM"),
    $752d21ce99232bca$var$load("6jAZt"),
    $752d21ce99232bca$var$load("jioFR"),
    $752d21ce99232bca$var$load("3cN9G"),
    $752d21ce99232bca$var$load("j3345"),
    $752d21ce99232bca$var$load("2J2X1"),
    $752d21ce99232bca$var$load("iBQFK"),
    $752d21ce99232bca$var$load("jgxNN"),
    $752d21ce99232bca$var$load("e7Dyr"),
    $752d21ce99232bca$var$load("XbUoB"),
    $752d21ce99232bca$var$load("iUz8S"),
    $752d21ce99232bca$var$load("6cD8V"),
    $752d21ce99232bca$var$load("2NEDA"),
    $752d21ce99232bca$var$load("dxcsb"),
    $752d21ce99232bca$var$load("gbejv"),
    $752d21ce99232bca$var$load("GD9EA"),
    $752d21ce99232bca$var$load("2hLAI"),
    $752d21ce99232bca$var$load("dCilB"),
    $752d21ce99232bca$var$load("1T8H1"),
    $752d21ce99232bca$var$load("fyKFO"),
    $752d21ce99232bca$var$load("d9sg7"),
    $752d21ce99232bca$var$load("l0N35"),
    $752d21ce99232bca$var$load("gnocL"),
    $752d21ce99232bca$var$load("j6n20"),
    $752d21ce99232bca$var$load("gpnR1"),
    $752d21ce99232bca$var$load("1Zk4x"),
    $752d21ce99232bca$var$load("8exG0"),
    $752d21ce99232bca$var$load("kT6dz"),
    $752d21ce99232bca$var$load("jZMUd"),
    $752d21ce99232bca$var$load("hzkGb"),
    $752d21ce99232bca$var$load("aClTZ"),
    $752d21ce99232bca$var$load("6wr18"),
    $752d21ce99232bca$var$load("bpmjT"),
    $752d21ce99232bca$var$load("hZVEi"),
    $752d21ce99232bca$var$load("ekVH8"),
    $752d21ce99232bca$var$load("ffEVr"),
    $752d21ce99232bca$var$load("dGhn8"),
    $752d21ce99232bca$var$load("5omeF"),
    $752d21ce99232bca$var$load("ddvkk"),
    $752d21ce99232bca$var$load("3upHR"),
    $752d21ce99232bca$var$load("hhss7"),
    $752d21ce99232bca$var$load("Wowvf"),
    $752d21ce99232bca$var$load("eRhBr"),
    $752d21ce99232bca$var$load("hZ2FX"),
    $752d21ce99232bca$var$load("cKDij"),
    $752d21ce99232bca$var$load("7EorR"),
    $752d21ce99232bca$var$load("ce05o"),
    $752d21ce99232bca$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.809a594d.js.map
